var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Category = /** @class */ (function () {
    function Category() {
        var _this = this;
        this.CategoryEditFormInit = function (path, callback) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        this.CategoryDelete = function (path, callback) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        this.CategoryCreate = function (path, formData, method, callback) {
            if (method === void 0) { method = "POST"; }
            return __awaiter(_this, void 0, void 0, function () {
                var protocol, host, response, json;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            protocol = window.location.protocol;
                            host = window.location.host;
                            return [4 /*yield*/, fetch("".concat(protocol, "//").concat(host).concat(path), {
                                    body: formData,
                                    method: method
                                })];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            json = _a.sent();
                            return [2 /*return*/, callback(json["hydra:member"])];
                    }
                });
            });
        };
        this.CategoryEdit = function (path, formData, method, callback) {
            if (method === void 0) { method = "POST"; }
            return __awaiter(_this, void 0, void 0, function () {
                var protocol, host, response, json;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            protocol = window.location.protocol;
                            host = window.location.host;
                            return [4 /*yield*/, fetch("".concat(protocol, "//").concat(host).concat(path), {
                                    body: JSON.stringify(formData),
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/ld+json'
                                        // 'Content-Type': 'application/x-www-form-urlencoded',
                                    },
                                })];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            json = _a.sent();
                            return [2 /*return*/, callback(json)];
                    }
                });
            });
        };
        this.CategoryInit = function (id, path, callback, page) {
            if (page === void 0) { page = 1; }
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this.LoadAPIPage(path, page, function (response, totalItemCount) { return __awaiter(_this, void 0, void 0, function () {
                        var table, thead, tableheaderrow, tableheadercells, tbody, new_tbody, responseCounter, rowId, new_row, counter, target, targets, cellData, tcounter, new_cell, td, Editbutton, th, _a, _b;
                        var _this = this;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    table = document.getElementById(id);
                                    table.dataset.page = page.toString();
                                    thead = table.getElementsByTagName("thead")[0];
                                    tableheaderrow = thead.getElementsByTagName("tr")[0];
                                    tableheadercells = thead.getElementsByTagName("th");
                                    tbody = table.getElementsByTagName("tbody")[0];
                                    if (tbody.parentNode != null) {
                                        new_tbody = document.createElement("tbody");
                                        tbody.parentNode.replaceChild(new_tbody, tbody);
                                        tbody = new_tbody;
                                    }
                                    for (responseCounter = 0; response.length > responseCounter; responseCounter++) {
                                        rowId = response[responseCounter]["@id"];
                                        new_row = document.createElement("tr");
                                        for (counter = 0; tableheadercells.length > counter; counter++) {
                                            target = tableheadercells[counter].dataset.target;
                                            targets = target.split(".");
                                            cellData = response[responseCounter][targets[0]];
                                            for (tcounter = 1; targets.length > tcounter; tcounter++) {
                                                cellData = cellData[targets[tcounter]];
                                            }
                                            new_cell = document.createElement("td");
                                            new_cell.innerText = cellData;
                                            new_row.append(new_cell);
                                        }
                                        td = document.createElement("td");
                                        Editbutton = document.createElement("button");
                                        Editbutton.classList.add("btn");
                                        Editbutton.classList.add("btn-primary");
                                        Editbutton.classList.add("btn-sm");
                                        Editbutton.classList.add("mb-4");
                                        Editbutton.dataset.toggle = "modal";
                                        Editbutton.dataset.target = "#modalEditForm";
                                        Editbutton.innerText = "Edit";
                                        Editbutton.dataset.rowId = rowId;
                                        Editbutton.addEventListener("click", function (e) {
                                            var modalId = e.target.dataset.target;
                                            var rowId = e.target.dataset.rowId;
                                            modalId = modalId.replace("#", "");
                                            var modal = document.getElementById(modalId);
                                            var modalBody = modal.getElementsByClassName("modal-body")[0];
                                            var inputs = modalBody.getElementsByTagName("input");
                                            _this.LoadAPISingleRecored(rowId, function (response) {
                                                console.log("Loaded edit");
                                                console.log(response);
                                                modal.getElementsByTagName("form")[0].dataset.rowId = rowId;
                                                for (var inputCounter = 0; inputs.length > inputCounter; inputCounter++) {
                                                    var target = inputs[inputCounter].dataset.target;
                                                    var targets = target.split(".");
                                                    var inputValue = response[targets[0]];
                                                    try {
                                                        for (var tcounter = 1; targets.length > tcounter; tcounter++) {
                                                            inputValue = inputValue[targets[tcounter]];
                                                        }
                                                        inputs[inputCounter].value = inputValue;
                                                        inputs[inputCounter].parentNode.classList.add("animated");
                                                    }
                                                    catch (e) { }
                                                }
                                            });
                                        });
                                        td.append(Editbutton);
                                        new_row.append(td);
                                        // class="btn btn-primary btn-sm mb-4" data-toggle="modal" data-target="#modalImportForm"
                                        tbody.append(new_row);
                                    }
                                    th = document.createElement("th");
                                    th.innerText = "Options";
                                    tableheaderrow.append(th);
                                    _b = (_a = table).after;
                                    return [4 /*yield*/, this.CreateTablePagination(table, path, totalItemCount, 30, page)];
                                case 1:
                                    _b.apply(_a, [_c.sent()]);
                                    console.log(tableheadercells);
                                    console.log(response);
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [2 /*return*/];
                });
            });
        };
        this.LoadPaginationApiPage = function (e, page, path, table) { return __awaiter(_this, void 0, void 0, function () {
            var tbody, new_tbody, thead, tableheadercells;
            var _this = this;
            return __generator(this, function (_a) {
                e.preventDefault();
                console.log(table);
                tbody = table.getElementsByTagName("tbody")[0];
                if (tbody.parentNode != null) {
                    new_tbody = document.createElement("tbody");
                    tbody.parentNode.replaceChild(new_tbody, tbody);
                    tbody = new_tbody;
                }
                table.dataset.page = page.toString();
                thead = table.getElementsByTagName("thead")[0];
                tableheadercells = thead.getElementsByTagName("th");
                this.LoadAPIPage(path, page, function (response, totalItemCount) { return __awaiter(_this, void 0, void 0, function () {
                    var responseCounter, new_row, counter, target, targets, cellData, tcounter, new_cell, _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                for (responseCounter = 0; response.length > responseCounter; responseCounter++) {
                                    new_row = document.createElement("tr");
                                    for (counter = 0; tableheadercells.length > counter; counter++) {
                                        target = tableheadercells[counter].dataset.target;
                                        targets = target.split(".");
                                        cellData = response[responseCounter][targets[0]];
                                        for (tcounter = 1; targets.length > tcounter; tcounter++) {
                                            cellData = cellData[targets[tcounter]];
                                        }
                                        new_cell = document.createElement("td");
                                        new_cell.innerText = cellData;
                                        new_row.append(new_cell);
                                    }
                                    tbody.append(new_row);
                                }
                                _b = (_a = table).after;
                                return [4 /*yield*/, this.CreateTablePagination(table, path, totalItemCount, 30, page)];
                            case 1:
                                _b.apply(_a, [_c.sent()]);
                                return [2 /*return*/];
                        }
                    });
                }); });
                console.log("Previous");
                return [2 /*return*/];
            });
        }); };
        this.LoadPreviousApiPage = function (e, path, table) { return __awaiter(_this, void 0, void 0, function () {
            var tbody, new_tbody, page, thead, tableheadercells;
            var _this = this;
            return __generator(this, function (_a) {
                e.preventDefault();
                console.log(table);
                tbody = table.getElementsByTagName("tbody")[0];
                if (tbody.parentNode != null) {
                    new_tbody = document.createElement("tbody");
                    tbody.parentNode.replaceChild(new_tbody, tbody);
                    tbody = new_tbody;
                }
                page = Number(table.dataset.page) == 1 ? 1 : Number(table.dataset.page) - 1;
                table.dataset.page = page.toString();
                thead = table.getElementsByTagName("thead")[0];
                tableheadercells = thead.getElementsByTagName("th");
                this.LoadAPIPage(path, page, function (response, totalItemCount) { return __awaiter(_this, void 0, void 0, function () {
                    var responseCounter, new_row, counter, target, targets, cellData, tcounter, new_cell, _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                for (responseCounter = 0; response.length > responseCounter; responseCounter++) {
                                    new_row = document.createElement("tr");
                                    for (counter = 0; tableheadercells.length > counter; counter++) {
                                        target = tableheadercells[counter].dataset.target;
                                        targets = target.split(".");
                                        cellData = response[responseCounter][targets[0]];
                                        for (tcounter = 1; targets.length > tcounter; tcounter++) {
                                            cellData = cellData[targets[tcounter]];
                                        }
                                        new_cell = document.createElement("td");
                                        new_cell.innerText = cellData;
                                        new_row.append(new_cell);
                                    }
                                    tbody.append(new_row);
                                }
                                _b = (_a = table).after;
                                return [4 /*yield*/, this.CreateTablePagination(table, path, totalItemCount, 30, page)];
                            case 1:
                                _b.apply(_a, [_c.sent()]);
                                return [2 /*return*/];
                        }
                    });
                }); });
                console.log("Previous");
                return [2 /*return*/];
            });
        }); };
        this.LoadNextApiPage = function (e, path, table) { return __awaiter(_this, void 0, void 0, function () {
            var tbody, new_tbody, page, thead, tableheadercells;
            var _this = this;
            return __generator(this, function (_a) {
                e.preventDefault();
                console.log(table);
                tbody = table.getElementsByTagName("tbody")[0];
                if (tbody.parentNode != null) {
                    new_tbody = document.createElement("tbody");
                    tbody.parentNode.replaceChild(new_tbody, tbody);
                    tbody = new_tbody;
                }
                page = Number(table.dataset.page) + 1;
                table.dataset.page = page.toString();
                thead = table.getElementsByTagName("thead")[0];
                tableheadercells = thead.getElementsByTagName("th");
                this.LoadAPIPage(path, page, function (response, totalItemCount) { return __awaiter(_this, void 0, void 0, function () {
                    var responseCounter, new_row, counter, target, targets, cellData, tcounter, new_cell, _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                for (responseCounter = 0; response.length > responseCounter; responseCounter++) {
                                    new_row = document.createElement("tr");
                                    for (counter = 0; tableheadercells.length > counter; counter++) {
                                        target = tableheadercells[counter].dataset.target;
                                        targets = target.split(".");
                                        cellData = response[responseCounter][targets[0]];
                                        for (tcounter = 1; targets.length > tcounter; tcounter++) {
                                            cellData = cellData[targets[tcounter]];
                                        }
                                        new_cell = document.createElement("td");
                                        new_cell.innerText = cellData;
                                        new_row.append(new_cell);
                                    }
                                    tbody.append(new_row);
                                }
                                _b = (_a = table).after;
                                return [4 /*yield*/, this.CreateTablePagination(table, path, totalItemCount, 30, page)];
                            case 1:
                                _b.apply(_a, [_c.sent()]);
                                return [2 /*return*/];
                        }
                    });
                }); });
                console.log("Next");
                return [2 /*return*/];
            });
        }); };
        this.CreateTablePagination = function (table, path, totalItemCount, pageItemCount, page) {
            if (page === void 0) { page = 1; }
            return __awaiter(_this, void 0, void 0, function () {
                var nav, ul, old_pagination, previousli, previousLink, nextli, nextLink, pages, _loop_1, counter;
                var _this = this;
                return __generator(this, function (_a) {
                    nav = document.createElement("nav");
                    ul = document.createElement("ul");
                    old_pagination = document.getElementById("".concat(table.id, "-pagination"));
                    if (old_pagination != null) {
                        old_pagination.remove();
                    }
                    ul.classList.add("pagination");
                    ul.id = "".concat(table.id, "-pagination");
                    previousli = document.createElement("li");
                    previousli.classList.add("page-item");
                    previousli.dataset.prevpage = "true";
                    previousLink = document.createElement("a");
                    previousLink.classList.add("page-link");
                    previousLink.href = "#";
                    previousLink.innerText = "Previous";
                    previousLink.addEventListener("click", function (e) { return _this.LoadPreviousApiPage(e, path, table); });
                    previousli.append(previousLink);
                    ul.append(previousli);
                    nextli = document.createElement("li");
                    nextli.classList.add("page-item");
                    nextli.dataset.nextpage = "true";
                    nextLink = document.createElement("a");
                    nextLink.classList.add("page-link");
                    nextLink.href = "#";
                    nextLink.innerText = "Next";
                    nextLink.addEventListener("click", function (e) { return _this.LoadNextApiPage(e, path, table); });
                    nextli.append(nextLink);
                    pages = Math.ceil(totalItemCount / pageItemCount);
                    _loop_1 = function (counter) {
                        var li = document.createElement("li");
                        li.dataset.targetpage = counter.toString();
                        li.classList.add("page-item");
                        var link = document.createElement("a");
                        link.classList.add("page-link");
                        link.href = "#";
                        link.addEventListener("click", function (e) { return _this.LoadPaginationApiPage(e, counter, path, table); });
                        link.innerText = counter.toString();
                        if (counter == page) {
                            link.classList.add("bg-primary");
                            link.classList.add("text-white");
                            link.dataset.disabled = "true";
                        }
                        li.append(link);
                        ul.append(li);
                    };
                    for (counter = 1; pages >= counter; counter++) {
                        _loop_1(counter);
                    }
                    ul.append(nextli);
                    nav.append(ul);
                    return [2 /*return*/, nav];
                });
            });
        };
        this.LoadAPISingleRecored = function (path, callback) { return __awaiter(_this, void 0, void 0, function () {
            var protocol, host, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        protocol = window.location.protocol;
                        host = window.location.host;
                        console.log("".concat(protocol, "//").concat(host).concat(path));
                        return [4 /*yield*/, fetch("".concat(protocol, "//").concat(host).concat(path))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, callback(json)];
                }
            });
        }); };
        this.LoadAPIPage = function (path, page, callback) { return __awaiter(_this, void 0, void 0, function () {
            var protocol, host, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        protocol = window.location.protocol;
                        host = window.location.host;
                        console.log("".concat(protocol, "//").concat(host).concat(path, "?page=").concat(page));
                        return [4 /*yield*/, fetch("".concat(protocol, "//").concat(host).concat(path, "?page=").concat(page))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, callback(json["hydra:member"], json["hydra:totalItems"])];
                }
            });
        }); };
        this.AddShowModal = function (fields) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log(fields);
                return [2 /*return*/];
            });
        }); };
    }
    return Category;
}());
export { Category };
var FormField = /** @class */ (function () {
    function FormField(fieldName, fieldType, fieldData) {
        this.fieldName = fieldName;
        this.fieldType = fieldType;
        this.fieldData = fieldData;
    }
    return FormField;
}());
export { FormField };
